"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOptions = void 0;
exports.defaultOptions = {
    preserveFrontmatter: true,
    preserveHtml: true,
    preserveComment: true,
    preserveBrace: true,
    preserveBracket: true,
    preserveUri: true,
    preserveNbsp: true,
    preserveEntity: true,
    fixEOL: true,
    fixStandardChars: true,
    fixDashes: true,
    fixEllipsis: true,
    fixEnglishQuotes: true,
    removeRLM: true,
    fixZWNJ: true,
    fixArabicNumbers: true,
    fixEnglishNumbers: true,
    fixNumeralSymbols: true,
    fixPunctuations: true,
    fixNonPersianChars: true,
    fixQuestionMarks: true,
    fixDates: true,
    fixHamzeh: true,
    fixArabicHamzeh: true,
    fixSuffixZwnj: true,
    fixPrefixZwnj: true,
    fixBracesSpacing: true,
    fixBracesSpacingInside: true,
    removeExtraMarks: true,
    fixPunctuationSpacing: true,
    removeKashidas: true,
    fixMiscSpacing: true,
    removeDiacritics: true,
    fixDiacritics: true,
    removeSpaces: true,
    fixLineBreaks: true,
    trim: true,
};
